export default "__VITE_ASSET__2c8fa752__"